import { observable, action } from 'mobx';
import agent from '../agent';
import commonStore from './commonStore';
import constants from '../constants';
import userStore from './userStore';

export class DashboardStore {
    @observable selectAllDocs = false;
    @observable selectedDocs = [];
    @observable openActionSnackbar = false;
    @observable documentList = [];
    @observable countData = {};
    @observable inProgress = false;
    @observable files = [];
    @observable statusText;
    @observable errors;
    @observable enterpriseData = {};
    @observable totalDocs = 0
    @observable processingStatus = {
        totalDocs: 0,
        processedCount: 0
    };
    @observable openUploadDialog = false;
    @observable openFileAssignDialog = false;
    @observable uploadIcon = "close";
    @observable uploadedFiles = [];
    @observable uploadedFolders = [];
    @observable pageNo = 0;
    @observable menuArray = [];
    @observable currentId = undefined;
    @observable searchText = undefined;
    @observable stopUpdating = false
    @observable messageType = 'error';
    @observable selectedDocType = ''
    @observable tableHeader = [
        { name: 'Name', type: 'originalFileName', sort: 1, category: ['drafts', 'reviewed', 'exported', 'ai pending'], userType: ['AGENT', 'ADMIN', 'SUPER_ADMIN'], allowSort: true, width: '16vw' },
        { name: 'Status', type: 'docStatus', sort: 1, category: ['drafts'], userType: ['AGENT', 'ADMIN', 'SUPER_ADMIN'], allowSort: false, width: '13vw' },
        { name: 'Assigned To', type: 'assignedTo', sort: 1, category: ['drafts', 'ai pending'], userType: ['AGENT', 'ADMIN', 'SUPER_ADMIN'], allowSort: false, width: '13vw' },
        { name: 'Reviewed By', type: 'reviewedBy', sort: 1, category: ['reviewed', 'exported'], userType: ['AGENT', 'ADMIN', 'SUPER_ADMIN'], allowSort: false, width: '13vw' },
        { name: 'Type', type: 'docType', sort: 1, category: [], allowSort: true, width: '13vw' },
        { name: 'Enterprise', type: 'enterpriseId', sort: 1, category: ['drafts', 'reviewed', 'exported', 'ai pending'], userType: ['SUPER_ADMIN'], allowSort: false, width: '13vw' },
        { name: 'Reviewed At', type: 'reviewedAt', sort: 1, category: ['reviewed'], userType: ['AGENT', 'ADMIN', 'SUPER_ADMIN'], allowSort: true, width: '13vw' },
        { name: 'Received At', type: 'createdAt', sort: 1, category: ['drafts', 'ai pending'], userType: ['ADMIN', 'SUPER_ADMIN'], allowSort: true, width: '13vw' },
        { name: 'Assigned At', type: 'assignedAt', sort: 1, category: ['drafts'], userType: ['AGENT'], allowSort: true, width: '13vw' },
        { name: 'Exported At', type: 'exportedAt', sort: 1, category: ['exported'], userType: ['AGENT', 'ADMIN', 'SUPER_ADMIN'], allowSort: true, width: '13vw' },
        { name: 'Sequence No.', type: 'sequence_no', sort: 1, category: ['drafts', 'reviewed', 'exported', 'ai pending'], userType: ['AGENT', 'ADMIN', 'SUPER_ADMIN'], allowSort: true, width: '13vw' },
    ]

    @action handleSelectAll(value) {
        this.selectAllDocs = value;
        this.selectedDocs = new Array(this.documentList.length).fill(value);
        this.openActionSnackbar = value;
    }

    @action setPageNumber(num) {
        this.pageNo = num;
    }

    @action resetSelectedDocuments() {
        this.selectAllDocs = false;
        this.closeActionSnackbar();
        this.selectedDocs = new Array(this.documentList.length).fill(false);
    }

    @action setSelectedDocs(index, value) {
        if (!value)
            this.selectAllDocs = value;
        this.selectedDocs[index] = value
        if (this.selectedDocs.indexOf(true) > -1)
            this.openActionSnackbar = true;
        else {
            this.closeActionSnackbar();
            this.selectedDocs = new Array(this.documentList.length).fill(value)
        }
    }

    @action closeActionSnackbar() {
        this.openActionSnackbar = false;
    }

    //File Actions - Export 
    @action exportDocuments(filter) {
        let temp = []
        for (let i = 0; i < this.selectedDocs.length; i++) {
            if (this.selectedDocs[i])
                temp.push(this.documentList[i]._id)
        }
        this.exportXls(temp, filter)
    }

    //File Actions - Download 
    @action downloadBulkDocs(filter) {
        let temp = []
        for (let i = 0; i < this.selectedDocs.length; i++) {
            if (this.selectedDocs[i])
                temp.push(this.documentList[i]._id)
        }
        this.downloadOriginalDoc(temp, filter)
    }

    @action exportXls(docList, filter) {
        this.statusText = '';
        this.errors = undefined;
        this.downloadProgress = true;
        return agent.Documents.getDownloadTokenForXls(docList)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    let link = document.createElement('a');
                    link.href = constants.API_ROOT + `/upload/downloadXls?downloadToken=${response.data.downloadToken}&fileName=${response.data.fileName}`
                    link.click();
                    if (userStore.user.userType === 'SUPER_ADMIN')
                        this.sortDocumentList(filter, 'createdAt', -1)
                    else
                        this.getFilteredDocuments(filter);
                    commonStore.handleOpenSnackBar(`Document exported successfully. It will now be available under "Exports"`, 'success')
                }
                else
                    commonStore.handleOpenSnackBar(response.message, 'error')
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.downloadProgress = false
            }))
    }

    //File Actions - delete 
    @action deleteMultipleDocs(filter) {
        let temp = []
        for (let i = 0; i < this.selectedDocs.length; i++) {
            if (this.selectedDocs[i])
                temp.push(this.documentList[i]._id)
        }
        this.deleteDocument(temp, filter)
    }

    @action resetMenuArray() {
        this.menuArray = new Array(this.documentList.length).fill(false);
    }

    @action openMenu(e, index) {
        this.menuArray[index] = e.currentTarget
    }

    @action deleteDocument(docId, filter) {
        this.statusText = '';
        this.errors = undefined;
        this.inProgress = true;
        this.messageType = 'error';
        return agent.Documents.deleteDocument(docId)
            .then(action((response) => {
                this.resetSelectedDocuments()
                this.resetMenuArray()
                if (response.statusCode == "200") {
                    this.messageType = 'success'
                    if (userStore.user.userType === 'SUPER_ADMIN')
                        this.sortDocumentList(filter, 'createdAt', -1)
                    else
                        this.fetchDocumentList(filter)
                }
                commonStore.handleOpenSnackBar(response.message, this.messageType)


            }))
            .catch(action((err) => {
                commonStore.handleOpenSnackBar('Failed to delete documents', this.messageType)
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }


    //Get document list
    @action fetchDocumentList(filter) {

        if (userStore.user.userType !== 'SUPER_ADMIN') {
            if (filter === "REVIEW_PENDING")
                this.getHomePageData();
            else {
                if (filter == "REVIEW_COMPLETED")
                    this.getFilteredDocuments(filter)
                else
                    this.getFilteredDocuments(filter)
            }
        }
        else
            this.getGlobalDocumentList(filter)
    }

    @action resetSearch = () => {
        this.searchText = undefined;
    }

    @action setCountData(countData) {
        this.countData = countData
    }

    //Get document list according to export/reviewed statuses
    @action getFilteredDocuments(filter, sortField, sortDirection) {
        this.statusText = '';
        this.errors = undefined;
        this.noMatchFound = false;
        this.inProgress = true;
        let temp = { sortField, sortDirection }
        if (sortField === undefined)
            temp = this.getSortField(filter)
        return agent.Dashboard.getFilteredDocuments(filter, temp.sortField, temp.sortDirection, this.searchText)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.documentList = response.data.documentList;
                    this.resetSelectedDocuments();
                    this.resetMenuArray()
                    this.countData = response.data.countData;
                    this.totalDocs = response.data.totalDocs
                    this.processingStatus = response.data.processingStatus;
                }
                else {
                    this.documentList = [];
                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action getPeriodicDocList(filter) {
        if (this.stopUpdating || this.selectedDocs.length)
            return
        this.statusText = '';
        this.errors = undefined;
        this.noMatchFound = false;
        let temp = this.getSortField(filter)
        return agent.Dashboard.getFilteredDocuments(filter, temp.sortField, temp.sortDirection)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.documentList = response.data.documentList;
                    this.resetSelectedDocuments();
                    this.resetMenuArray()
                    this.enterpriseData = response.data.enterpriseData;
                    this.processingStatus = response.data.processingStatus;
                    this.countData = response.data.countData;

                }
                else {
                    this.documentList = [];
                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
            }))
    }




    @action getHomePageData(sortField, sortDirection) {
        this.statusText = '';
        this.errors = undefined;
        this.noMatchFound = false;
        this.inProgress = true;
        let temp = { sortField, sortDirection }
        if (sortField === undefined)
            temp = this.getSortField('REVIEW_PENDING')
        return agent.Dashboard.getHomePageData(temp.sortField, temp.sortDirection, this.searchText)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.documentList = response.data.documentList;
                    this.resetSelectedDocuments();
                    this.resetMenuArray()
                    this.enterpriseData = response.data.enterpriseData;
                    this.processingStatus = response.data.processingStatus;
                    this.countData = response.data.countData;
                    this.totalDocs = response.data.totalDocs
                    if (response.data.isLocalTemplatePresent)
                        userStore.setLocalTemplate()
                }
                else {
                    this.documentList = [];
                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }

    @action setUploadFiles(files) {
        this.files = this.files.concat(Array.from(files))
        this.files.forEach(function (element) {
            element.uploadIcon = "close";
        });
    }

    @action closeFileActions() {
        this.openFileActions = false;
    }

    @action closeUploadDialog() {
        this.openUploadDialog = false;
    }

    @action closeFileAssignDialog() {
        this.openFileAssignDialog = false;
        this.closeActionSnackbar();
        this.currentId = undefined
        userStore.closeDialog()
    }

    @action openFileAssign(id) {
        this.currentId = id
        this.openFileAssignDialog = true;
        this.closeActionSnackbar()
    }

    @action removeFile(index) {
        this.files.splice(index, 1);
    }

    @action openUpload(assignedUser, comment, docType) {
        let index = userStore.userList.findIndex(x => x.email === assignedUser.split(",")[1])
        this.assignedUser = userStore.userList[index];
        this.assignedUser.comment = comment;
        this.openFileAssignDialog = false
        this.openUploadDialog = true;
        this.selectedDocType = docType
    }

    @action sortDocumentList(filter, sortField, sortDirection) {
        let index = this.tableHeader.findIndex(x => x.type === sortField);
        this.tableHeader.forEach((el) => { el.sort = 1 })
        this.tableHeader[index].sort = sortDirection;
        if (userStore.user.userType !== 'SUPER_ADMIN') {
            if (filter === "REVIEW_PENDING")
                this.getHomePageData(sortField, sortDirection);
            else
                this.getFilteredDocuments(filter, sortField, sortDirection)
        }
        else {
            this.getGlobalDocumentList(filter, sortField, sortDirection)
        }
    }


    @action getSortField(filter) {
        let counts = this.tableHeader.reduce((c, { sort: key }) => (c[key] = (c[key] || 0) + 1, c), {});
        let sortDirection = (counts[-1] === 1) ? -1 : 1;
        let index = this.tableHeader.findIndex(x => x.sort === -1);
        if (index > -1)
            return { sortField: this.tableHeader[index].type, sortDirection: sortDirection }
        else {
            if (filter === "REVIEW_PENDING") {
                let index = this.tableHeader.findIndex(x => x.type === 'createdAt');
                this.tableHeader[index].sort = -1
                return { sortField: 'createdAt', sortDirection: -1 }


            }
            else if (filter === "REVIEW_COMPLETE") {
                let index = this.tableHeader.findIndex(x => x.type === 'reviewedAt');
                this.tableHeader[index].sort = -1
                return { sortField: 'reviewedAt', sortDirection: -1 }

            }
            else {
                let index = this.tableHeader.findIndex(x => x.type === 'exportedAt');
                this.tableHeader[index].sort = -1
                return { sortField: 'exportedAt', sortDirection: -1 }

            }
        }

    }

    @action resetFiles() {
        this.files = [];
        this.uploadIcon = "close";
        this.openUploadDialog = false;
        this.uploadedFolders = []
    }

    @action expandUploadedFolder(index) {
        this.uploadedFolders[index].expanded = !this.uploadedFolders[index].expanded;
    }

    @action cancelUpload() {
        this.files = [];
        this.uploadedFolders = [];
        this.uploadIcon = "close";
        this.closeUploadDialog()
    }

    @action setupUploadResponse(uploadData) {
        let temp = []
        for (let i = 0; i < this.files.length; i++) {
            if (uploadData.invalidFilesArray.length && uploadData.invalidFilesArray.indexOf(this.files[i].name) > -1)
                this.files[i].uploadIcon = "error"
            else if (uploadData.validFilesArray.length && uploadData.validFilesArray.indexOf(this.files[i].name) > -1)
                this.files[i].uploadIcon = "right"
            else
                this.files.splice(i, 1)
        }


        if (uploadData.extractedDataArray.length) {
            uploadData.extractedDataArray.forEach(folder => {
                let obj = {}
                obj.folderName = folder.folderName;
                obj.files = [];
                obj.expanded = true;
                if (folder.filesArray.length) {
                    folder.filesArray.forEach(
                        file => {
                            let tempObj = {};
                            tempObj.name = file;
                            tempObj.uploadIcon = "right";
                            obj.files.push(tempObj)
                        }
                    )
                }
                if (folder.invalidFilesArray.length) {
                    folder.invalidFilesArray.forEach(
                        file => {
                            let tempObj = {};
                            tempObj.name = file;
                            tempObj.uploadIcon = "error"
                            obj.files.push(tempObj)
                        }
                    )
                }
                this.uploadedFolders.push(obj)
            })
        }
        this.uploadedFiles = temp;
    }

    @action uploadFiles() {
        this.resumeUpdating()
        this.statusText = '';
        this.errors = undefined;
        this.uploadProgress = true;
        this.openUploadDialog = true;
        this.uploadIcon = "progress";
        return agent.Dashboard.uploadFiles(this.files, this.assignedUser._id, this.assignedUser.comment, this.selectedDocType === 'ATM_SLIPS' ? 'WRITERCORP' : this.selectedDocType)
            .then(action((response) => {
                this.uploadStatus = response;
                if (response.statusCode == "200") {
                    this.uploadProgress = false
                    this.pageNo = 0;
                    this.setupUploadResponse(response.uploadData)
                    this.uploadIcon = "";
                    if (userStore.user.userType === 'SUPER_ADMIN') {
                        this.sortDocumentList('AI_PENDING', 'createdAt', -1)
                        commonStore.setActiveTab("ai pending")
                    }

                    else
                        this.getHomePageData('createdAt', -1);
                    commonStore.handleOpenSnackBar(response.message, 'success')
                }
                else {
                    this.resetFiles();
                    commonStore.handleOpenSnackBar(response.message, 'error')
                }

            }))
            .catch(action((err) => {
                //this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.uploadProgress = false;
            }))

    }

    @action resumeUpdating = () => {
        console.log('updating')
        this.stopUpdating = false
    }

    @action searchDocuments(searchText, filter) {
        this.searchText = searchText;
        this.stopUpdating = true
        if (userStore.user.userType === 'SUPER_ADMIN')
            this.getGlobalDocumentList(filter)
        else {
            if (filter === "REVIEW_PENDING")
                this.getHomePageData()
            else
                this.getFilteredDocuments(filter)
        }
    }

    @action downloadOriginalDoc(documentId) {
        this.statusText = '';
        this.errors = undefined;
        this.downloadProgress = true;
        return agent.Documents.getDownloadTokenForDoc(documentId)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    let link = document.createElement('a');
                    link.href = constants.API_ROOT + `/upload/downloadOriginalDoc?downloadToken=${response.data.downloadToken}&fileName=${response.data.fileName}`
                    link.click();
                }

            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.downloadProgress = false
            }))
    }

    //Get document list for super admin
    @action getGlobalDocumentList(filter, sortField, sortDirection) {

        this.statusText = '';
        this.errors = undefined;
        this.noMatchFound = false;
        this.inProgress = true;
        let temp = { sortField, sortDirection }
        if (sortField === undefined)
            temp = this.getSortField(filter)
        return agent.SuperAdmin.getGlobalDocumentList(filter, temp.sortField, temp.sortDirection, this.searchText)
            .then(action((response) => {
                if (response.statusCode == '200') {
                    this.documentList = response.data.documentList;
                    this.resetSelectedDocuments();
                    this.resetMenuArray()
                    this.countData = response.data.countData;
                    this.totalDocs = response.data.totalDocs;
                    this.processingStatus = response.data.processingStatus;
                }
                else {
                    this.documentList = [];
                }
            }))
            .catch(action((err) => {
                this.errors = err.response && err.response.body && err.response.body.errors;
            }))
            .finally(action(() => {
                this.inProgress = false;
            }))
    }
}


export default new DashboardStore();
